import StateLoading from 'app/KinerjaKSPage/components/StateLoading'

import type { FC } from 'react'

type Props = {}

const PageSpinner: FC<Props> = ({}) => {
  return <StateLoading />
}

export default PageSpinner
